/** Displays a Font-Awesome delete icon (fa-trash) */
export const deleteIconFormatter = () => `<i class="fa fa-trash pointer delete-icon" aria-hidden="true"></i>`;
//# sourceMappingURL=deleteIconFormatter.js.map